const jimmyPlayerSpritesheet = {
  "name": "jimmyPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/jimmyPlayerSpritesheet.png",
  "sprites": {
    "jimmyPlayerHead": [0],
    "jimmyPlayerBody": [1]
  }
}
export default jimmyPlayerSpritesheet;
